import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewChange_Insumo = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'change_insumos',
        name: 'Cambio De Insumo',
        component: ViewChange_Insumo,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
